import { Box } from '@coolblue-development/becky';
import { useState } from 'react';
import { EmailMessage } from '../../../../../models/Email';
import EmailHeaderContainer from './EmailHeaderContainer';
import { processEmailHtml } from '../../../../../utils/emailContactHelpers';
import EmailAttachmentChips from './EmailAttachmentChips';

interface EmailMessageItemProps {
  message: EmailMessage;
  index: number;
  initiallyCollapsed?: boolean;
  onAttachmentDownloadError?: () => void;
}

const EmailMessageItem = ({
  message,
  index,
  initiallyCollapsed = true,
  onAttachmentDownloadError
}: EmailMessageItemProps): JSX.Element => {
  const [isCollapsed, setIsCollapsed] = useState(initiallyCollapsed);

  return (
    <Box sx={{ maxWidth: '100%' }}>
      <EmailHeaderContainer message={message} onClick={() => setIsCollapsed(!isCollapsed)} isCollapsed={isCollapsed} />

      {!isCollapsed && (
        <Box
          id={`email-body-${index}`}
          sx={{
            marginX: '16px',
            marginBottom: '16px',
            borderRight: '1px solid #DDDDDD',
            borderLeft: '1px solid #DDDDDD',
            borderBottom: '1px solid #DDDDDD',
            borderRadius: '0 0 4px 4px',
            padding: '12px',
            maxHeight: '400px',
            overflow: 'auto',
            '& img': { maxWidth: '100%' },
            '& table': { maxWidth: '100%' }
          }}
        >
          {message.attachments && message.attachments.length > 0 && (
            <EmailAttachmentChips
              attachments={message.attachments}
              contactId={message.contactId}
              onDownloadError={onAttachmentDownloadError}
            />
          )}
          <Box dangerouslySetInnerHTML={{ __html: processEmailHtml(message.bodyHtml || '<em>No content</em>') }} />
        </Box>
      )}
    </Box>
  );
};

export default EmailMessageItem;
